import React from "react";

function RubriquesInline({ items, activeId, onSelect, rubriquesStatus }) {
  if (!items || items.length === 0) {
    return <div>Aucune rubrique disponible</div>;
  }

  return (
    <div className="rubriques-list">
      {items.map((item) => (
        <div
          key={item.id}
          role="button"
          tabIndex={0}
          aria-current={activeId === item.id ? 'true' : undefined}
          className={`rubrique-item ${activeId === item.id ? 'active' : ''} ${
            rubriquesStatus[item.id] === 'completed' ? 'completed' : ''
          }`}
          onClick={() => onSelect && onSelect(item.id)}
          onKeyDown={(e) => {
            if ((e.key === 'Enter' || e.key === ' ') && onSelect) {
              e.preventDefault();
              onSelect(item.id);
            }
          }}
        >
          <span className="rubrique-number">{item.id}</span>
          <span className="rubrique-title">{item.title}</span>
          <div
            className="rubrique-led"
            aria-hidden="true"
            data-status={rubriquesStatus[item.id] || 'default'}
          />
        </div>
      ))}
    </div>
  );
}

export default RubriquesInline;